import { render, staticRenderFns } from "./DataDictionary.vue?vue&type=template&id=d8c6dd72&scoped=true&"
import script from "./DataDictionary.vue?vue&type=script&lang=ts&"
export * from "./DataDictionary.vue?vue&type=script&lang=ts&"
import style0 from "./DataDictionary.vue?vue&type=style&index=0&id=d8c6dd72&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d8c6dd72",
  null
  
)

export default component.exports